import { useNavigate } from "react-router-dom";
import { imgUrl } from "@/lib/api";
import { useData } from "@/context/DataContext";
import { MapPin, Navigation, Star } from "lucide-react";
import { motion } from "framer-motion";

export default function BusinessCard({ business, index = 0 }) {
  const navigate = useNavigate();
  const { getCategory } = useData();
  const cat = getCategory(business.category);
  const badge = business.discount?.badge;
  const hasImg = !!business.hero_image_url;
  const mem = business.membership;
  const CatIcon = cat.icon;

  return (
    <motion.button
      data-testid={`business-card-${business.id}`}
      onClick={() => navigate(`/negocio/${business.id}`)}
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: Math.min(index * 0.05, 0.4), duration: 0.4 }}
      whileTap={{ scale: 0.98 }}
      className={`group w-full overflow-hidden rounded-2xl bg-white text-left shadow-[0_8px_30px_rgba(0,0,0,0.04)] ${
        business.featured ? "border-2 border-[#E54D2E]/40" : "border border-black/5"
      }`}
    >
      <div className="relative h-40 w-full overflow-hidden bg-[#F3F0E6]">
        {hasImg && (
          <img
            src={imgUrl(business.hero_image_url)}
            alt={business.name}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        )}
        <div className="absolute left-3 top-3 flex items-center gap-1.5 rounded-full bg-white/90 px-2.5 py-1 backdrop-blur">
          <CatIcon size={13} style={{ color: cat.color }} strokeWidth={2.4} />
          <span className="text-[11px] font-bold text-[#1A1A1A]">{cat.label}</span>
        </div>
        {badge && (
          <div className="absolute right-3 top-3 rounded-full bg-[#E54D2E] px-3 py-1 text-[11px] font-black uppercase tracking-wide text-white shadow-lg">
            {badge}
          </div>
        )}
        {business.featured ? (
          <div className="absolute bottom-3 left-3 flex items-center gap-1 rounded-full bg-[#1A1A1A] px-2.5 py-1 text-[10px] font-black uppercase tracking-wide text-white shadow-lg" data-testid={`featured-badge-${business.id}`}>
            <Star size={11} className="fill-[#FFB800] text-[#FFB800]" /> Destacado
          </div>
        ) : mem ? (
          <div
            className="absolute bottom-3 left-3 rounded-full px-2.5 py-1 text-[10px] font-black uppercase tracking-wide text-white shadow-lg"
            style={{ backgroundColor: mem.color }}
          >
            {mem.badge_label || mem.name}
          </div>
        ) : null}
      </div>
      <div className="p-4">
        <h3 className="font-display text-lg font-bold leading-tight text-[#1A1A1A]">
          {business.name}
        </h3>
        {business.discount?.title && (
          <p className="mt-0.5 text-sm font-semibold text-[#E54D2E]">{business.discount.title}</p>
        )}
        <div className="mt-2 flex items-center gap-1.5 text-[13px] text-[#5C5C5C]">
          {business.distance_km != null ? (
            <>
              <Navigation size={13} strokeWidth={2.2} />
              <span>{business.distance_km} km · {business.colonia || business.city}</span>
            </>
          ) : (
            <>
              <MapPin size={13} strokeWidth={2.2} />
              <span className="truncate">
                {business.colonia ? `${business.colonia}, ` : ""}{business.city}
              </span>
            </>
          )}
        </div>
      </div>
    </motion.button>
  );
}
